import {createStore, combineReducers, applyMiddleware} from "redux";
import thunk from "redux-thunk";
import Transaction_Reducer from "../reducers/Transaction";
import Auth from "../reducers/Auth";

export default () => {
    const store = createStore(
      combineReducers({
          Transaction: Transaction_Reducer,
          Auth: Auth
      }),
        applyMiddleware(thunk)
    );

    return store;
}